import React, { useContext, useState } from 'react';
import { AppContext } from '../main';

// Card component that gets layout-related props passed in
const FeatureCard = ({ icon, title, description, columnClass, iconSpacingClass }) => (
    <div className={columnClass}>
        <div>
            <img src={icon} className={iconSpacingClass} alt={title} />
            <h4>{title}</h4>
            <p>{description}</p>
        </div>
    </div>
);

const Section = (props) => {
    const { handleEditItem } = props;
    const { appState } = useContext(AppContext);
    const { serviceList = {
        // numberOfColumns: 4, // options: 1, 2, 3, 4
        // enableMobileStacking: true,
        // cardSpacing: 'mb-4', // e.g. 'mb-2', 'mb-4', 'mb-5'
        // iconSpacing: 'mb-3' // spacing below the icon

    },
        editMode = false } = appState;


    // === 🛠️ EASY TO EDIT LAYOUT SETTINGS (Plain English) ===
    // const [numberOfColumns, setNumberOfColumns] = useState(4); // options: 1, 2, 3, 4
    // const [enableMobileStacking, setEnableMobileStacking] = useState(true);
    // const [cardSpacing, setCardSpacing] = useState('mb-4'); // e.g. 'mb-2', 'mb-4', 'mb-5'
    // const [iconSpacing, setIconSpacing] = useState('mb-3'); // spacing below the icon

    // === 🔄 Convert friendly settings to Bootstrap classes ===
    const getColumnClass = () => {
        const colWidth = Math.floor(12 / serviceList?.numberOfColumns); // e.g. 4 for 3 columns
        const mobileClass = serviceList?.enableMobileStacking ? 'col-md-' : 'col-';
        return `col-lg-${colWidth} ${mobileClass}${colWidth} ${serviceList?.cardSpacing}`;

    };
    if (!serviceList?.features?.[0]) return null;

    return (
        <div className="container">
            <div className="row">
                {/* Header */}
                {(serviceList.subtitle || serviceList.title) && <>
                    <div className="col-lg-6">
                        {serviceList.subtitle && <div className="subtitle mb-3">{serviceList.subtitle}</div>}
                        {serviceList.title && <h2 className="mb-4">{serviceList.title}</h2>}
                    </div>
                    <div className="col-lg-6"></div>
                </>}

                {/* Feature cards */}
                {serviceList?.features.map((feature, index) => (
                    <FeatureCard
                        key={index}
                        {...feature}
                        columnClass={getColumnClass()}
                        iconSpacingClass={serviceList?.iconSpacing}
                    />
                ))}
            </div>
        </div>
    );
};

export default Section;
